// @flow
import {observable, action, computed} from 'mobx'
import {Store} from 'Store'

const defaults = {sourcePath: 'close'}

export class Compare {
  root: Store
  @observable ticker = ''
  @observable loading = false
  @observable loaded = false
  @observable visible = false
  @observable data = {}
  @observable params = Object.assign({}, defaults)
  @observable paramsToChange = Object.assign({}, defaults)

  constructor(rootStore: Store, ticker: string) {
    this.root = rootStore
    this.ticker = ticker
  }

  @computed get syntax() {
    return this.ticker.toLowerCase()
  }

  @computed get ident() {
    return this.ticker
  }

  @action remove = () => {
    this.root.analysis.change('compare', {})
  }

  @action setTicker(ticker: string) {
    this.ticker = ticker
  }

  @action changeParam = (key: string, value: string) => {
    this.paramsToChange[key] = value
  }

  @action commitChanges = () => {
    this.params = Object.assign({}, this.paramsToChange)
    this.load()
  }

  @action discardChanges = () => {
    this.paramsToChange = Object.assign({}, this.params)
  }

  @action toggleVisibility = () => {
    this.visible = !this.visible
  }

  @action async load() {
    this.loading = true
    this.loaded = false
    const {analysis} = this.root
    const {start_dt, end_dt, bar_size} = analysis
    const {sourcePath, ...params} = this.params
    const body = {reports:[{
      start_dt: start_dt.toISOString(),
      end_dt: end_dt.toISOString(),
      bar_size: bar_size,
      tickers: [this.ticker],
      syntax_parts: [{ident:`${sourcePath.toUpperCase()}_PRICE`,params:{...params}}]
    }]}

    try {
      const {reports} = await analysis.prepareReport(body)
      reports[0].syntax_part_reports_data.map(row => {
        const data = Object.assign({}, row)
        data.syntax_part.syntax = this.ticker
        this.data = analysis.processTickerData(data)
      })
      analysis.calculateChartData()
    } finally {
      this.loaded = true
      this.loading = false
    }
  }
}
